import { requestData } from "./utils";

export type PublishAuditEvent = {
  event_type: string;
  event_short_description: string;
  details: string;
  enterprise_id?: string;
  entity_id?: string;
  enterprise_name?: string;
};

export default class AuditModule {
  publishAuditEvents(data: PublishAuditEvent) {
    return requestData("POST", "/audit/publish_audit_events", data);
  }
}
